export default class FederationIsbjConfig {
    constructor(data) {
        this.hmacKey = data.hmacKey;
        this.hmacUsername = data.hmacUsername;
        this.certificatePassword = data.certificatePassword;
        this.extractedCertificates = data.certificates;
        this.hasCertificate = data.hasCertificate;
    }
}
